import { connect } from 'react-redux';
import { getActiveTab, paramsByJobIds } from './../reducers';
import { setDispatcherJobInfo } from './../actions';
import { dispatcher as dispatcherSelectors } from '../selectors';
import DispatcherSelectorComponent from './../Components/DispatcherSelectorComponent.jsx';

export const mapStateToProps = (state) => {
  const dispatcherJobsByName =
  dispatcherSelectors.recentDispatchersAndJobsByName(state)['jobs'] || {};
  const params = paramsByJobIds(state);

  return {
    jobsByName: dispatcherJobsByName,
    params: params,
    dispatcherInfo: dispatcherSelectors.getDispatcherJobInfo(state),
    activeTab: getActiveTab(state)
  };
};

export const mapDispatchToProps = (dispatch) => ({
  onSubmit: dispatcherJobInfo => {
    dispatch(setDispatcherJobInfo(dispatcherJobInfo));
  }
});


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DispatcherSelectorComponent);


// WEBPACK FOOTER //
// src/Containers/DispatcherSelectorContainer.jsx